(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;
  var dataEl = root.querySelector('[data-bundle-data]');
  var box = root.querySelector('[data-bundle]');
  if (!dataEl || !box) return;
  var D = JSON.parse(dataEl.textContent);
  var form = root.querySelector('form');
  var rowsEl = box.querySelector('[data-b-rows]');
  var fmt = new Intl.NumberFormat(box.getAttribute('data-locale'), { style: 'currency', currency: box.getAttribute('data-currency'), minimumFractionDigits: 0, maximumFractionDigits: 2 });
  var money = function (c) { return fmt.format(c / 100); };
  var mode = 1;
  var touched = false;

  function itemById(id) { return D.items.filter(function (i) { return i.id === id; })[0] || D.items[0]; }
  function firstAvail(item, pref) {
    var v = item.variants.filter(function (x) { return x.id === pref; })[0];
    if (v && v.a) return v.id;
    v = item.variants.filter(function (x) { return x.a; })[0] || item.variants[0];
    return v.id;
  }
  function pct(sum) { return sum >= D.t3min ? D.t3 : (sum >= D.t2min ? D.t2 : D.t1); }
  function currentVariantId() { var h = form.querySelector('[data-variant-id]'); return h ? parseInt(h.value, 10) : 0; }

  var curIdx = 0;
  D.items.forEach(function (it, i) { if (it.id === D.current) curIdx = i; });
  var second = D.items.length > 1 ? (curIdx + 1) % D.items.length : curIdx;
  var rows = [
    { item: D.items[curIdx].id, variant: currentVariantId() || D.items[curIdx].variants[0].id },
    { item: D.items[second].id, variant: firstAvail(D.items[second], 0) }
  ];

  function price(r) { return itemById(r.item).variants.filter(function (v) { return v.id === r.variant; })[0].p; }

  function buildRows() {
    rowsEl.innerHTML = '';
    rows.forEach(function (r, idx) {
      var it = itemById(r.item);
      var row = document.createElement('div');
      row.className = 'bundle__row';
      var img = document.createElement('img'); img.src = it.img || ''; img.alt = ''; row.appendChild(img);
      var cs = document.createElement('select'); cs.setAttribute('aria-label', 'Produkt');
      var groups = {};
      D.items.forEach(function (c) {
        var o = document.createElement('option'); o.value = c.id; o.textContent = c.color; if (c.id === r.item) o.selected = true;
        var g = c.type || '';
        if (!g) { cs.appendChild(o); return; }
        if (!groups[g]) { groups[g] = document.createElement('optgroup'); groups[g].label = g; cs.appendChild(groups[g]); }
        groups[g].appendChild(o);
      });
      cs.addEventListener('change', function () { touched = true; r.item = parseInt(cs.value, 10); r.variant = firstAvail(itemById(r.item), 0); buildRows(); update(); });
      row.appendChild(cs);
      var ss = document.createElement('select'); ss.setAttribute('aria-label', 'Größe');
      it.variants.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = v.t + (v.a ? '' : ' – ausverkauft'); o.disabled = !v.a; if (v.id === r.variant) o.selected = true; ss.appendChild(o); });
      ss.addEventListener('change', function () { r.variant = parseInt(ss.value, 10); update(); });
      row.appendChild(ss);
      rowsEl.appendChild(row);
    });
  }

  function update() {
    var vid = currentVariantId();
    var cur = itemById(D.current).variants.filter(function (v) { return v.id === vid; })[0] || itemById(D.current).variants[0];
    if (vid && rows[0].item === D.current) rows[0].variant = vid;
    var p1 = Math.round(cur.p * (100 - D.t1) / 100);
    box.querySelector('[data-b-single]').innerHTML = '<s>' + money(cur.p) + '</s>' + money(p1);
    box.querySelector('[data-b-single-note]').textContent = D.t1 + ' % Rabatt inklusive';
    var sum = price(rows[0]) + price(rows[1]);
    var pc = pct(sum);
    var after = Math.round(sum * (100 - pc) / 100);
    box.querySelector('[data-b-save]').textContent = 'SPARE ' + money(sum - after);
    box.querySelector('[data-b-price]').innerHTML = '<s>' + money(sum) + '</s>' + money(after);
    var next = pc === D.t1 ? D.t2min : (pc === D.t2 ? D.t3min : 0);
    var nextPct = pc === D.t1 ? D.t2 : D.t3;
    box.querySelector('[data-b-note]').textContent = 'Beliebige 2 Teile aus dem Shop · ' + pc + ' % Rabatt' + (next && sum < next ? ' · ab ' + money(next) + ' ' + nextPct + ' %' : '');
  }

  function loadAll() {
    var url = function (n) { return '/collections/all?view=bundle&page=' + n; };
    var get = function (n) { return fetch(url(n)).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); }); };
    get(1).then(function (first) {
      var pages = [Promise.resolve(first)];
      for (var n = 2; n <= first.pages; n++) pages.push(get(n));
      return Promise.all(pages);
    }).then(function (all) {
      var list = [];
      all.forEach(function (p) { list = list.concat(p.items); });
      list = list.filter(function (i) { return i.variants.some(function (v) { return v.a; }) || i.id === D.current; });
      if (!list.some(function (i) { return i.id === D.current; })) return;
      D.items = list;
      if (!touched) {
        var cur = itemById(D.current);
        var other = list.filter(function (i) { return i.id !== D.current && i.type !== cur.type; })[0] || list.filter(function (i) { return i.id !== D.current; })[0];
        if (other) { rows[1].item = other.id; rows[1].variant = firstAvail(other, 0); }
      }
      rows.forEach(function (r) { if (!itemById(r.item) || itemById(r.item).id !== r.item) { r.item = D.items[0].id; r.variant = firstAvail(D.items[0], 0); } });
      buildRows();
      update();
    }).catch(function () {});
  }

  form.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-option]')) setTimeout(update, 0);
  });
  box.addEventListener('change', function (e) {
    if (e.target.name !== 'bundle_mode') return;
    mode = parseInt(e.target.value, 10);
    box.querySelectorAll('[data-b-opt]').forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-b-opt') === String(mode)); });
    rowsEl.hidden = mode !== 2;
    var qty = form.querySelector('.qty'); if (qty) qty.style.display = mode === 2 ? 'none' : '';
    var pay = form.querySelector('.shopify-payment-button'); if (pay) pay.style.display = mode === 2 ? 'none' : '';
    if (mode === 2) update();
  });
  form.addEventListener('submit', function (e) {
    if (mode !== 2) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[data-add]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
    var items = rows.map(function (r) { return { id: r.variant, quantity: 1 }; });
    if (items[0].id === items[1].id) { items = [{ id: items[0].id, quantity: 2 }]; }
    fetch(box.getAttribute('data-cart-add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () { var c = document.querySelector('.header__cart'); if (c) c.click(); else window.location.href = box.getAttribute('data-cart'); })
      .catch(function () { alert('Ein Artikel konnte nicht hinzugefügt werden. Bitte Größe prüfen.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }, true);

  buildRows();
  update();
  loadAll();
})();
